<template>
  <footer class="footer">
    <div class="row-footer"></div>
    <section class="main-container ">
      <figure class="w-100 text-center mb-5">
        <router-link to="/">
          <!-- <img width="100" src="@/assets/images/logo.png" alt="" /> -->
          <img width="100" src="@/assets/images/svgs/logo.svg" alt="" />
        </router-link>
      </figure>
      <div class="content-footer">
        <div>
          <h6
            class="text-color-444 mb-3 mb-md-4 fontsize-large font-weight-bold"
          >
            درباره آنجل بار
          </h6>
          <p
            class="fontsize-medium m-0 text-justify "
            v-if="
              content &&
                content.settings &&
                content.settings.general &&
                content.settings.general.about_footer
            "
          >
            <span class="line-clamp-3">{{
              content.settings.general.about_footer
            }}</span>
            <!-- <router-link to="/about-us" v-if="aboutLink" class="text-dark pr-2 fontsize-medium ">ادامه ...</router-link> -->
            <DynamicLinker
              class="text-dark pr-2 fontsize-medium "
              v-if="findAboutLink(content.menu.footer)"
              :item="findAboutLink(content.menu.footer)"
              >{{ "ادامه ..." }}</DynamicLinker
            >
          </p>
        </div>
        <div class="quick-access ">
          <div>
            <h6
              class="text-color-444 mb-3 mb-md-4 fontsize-large font-weight-bold"
            >
              دسترسی سریع
            </h6>
            <nav>
              <ul
                class="nav fontsize13 d-flex flex-column align-items-start"
                style="gap: 10px;"
              >
                <template v-if="!loading">
                  <li
                    v-for="item in content.menu.footer"
                    :key="item.id"
                    class="nav-item fontsize-medium mr-1"
                  >
                    <DynamicLinker :item="item">{{ item.title }}</DynamicLinker>
                  </li>
                </template>
                <template v-else>
                  <li v-for="index in 5" :key="index" class="nav-item">
                    <a class="nav-link">
                      <b-skeleton width="40px" />
                    </a>
                  </li>
                </template>
              </ul>
            </nav>
          </div>
          <div class="enamad-box enamad-mobile">
            <!-- <a
              data-v-76b5372e=""
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=333878&amp;Code=rPWS2Gf47zh4FD6LE0u7"
              ><img
                data-v-76b5372e=""
                referrerpolicy="origin"
                src="../../../../assets/images/enamd_log.png"
                alt=""
                id="rPWS2Gf47zh4FD6LE0u7"
                style="cursor: pointer;"
            /></a> -->

            <a
              target="_blank"
              href="https://trustseal.enamad.ir/?id=682193&Code=lq2TFifdO5YHTEgS5YMrdZzBzdnsJuGK"
              ><img
                referrerpolicy="origin"
                src="../../../../assets/images/enamd_log.png"
                alt=""
                style="cursor:pointer"
                code="lq2TFifdO5YHTEgS5YMrdZzBzdnsJuGK"
            /></a>
          </div>
        </div>
        <address class="footer__box m-0">
          <h6
            class="text-color-444 mb-3 mb-md-4 fontsize-large font-weight-bold"
          >
            ارتباط با ما
          </h6>

          <div class="contact-footer">
            <!-- <p class="m-0 fontsize-medium d-inline-block">
              <b class=" fontsize-medium d-inline-block pr-1">
                آدرس :
              </b>
              <span>
                {{ content.settings.shop_info.shop_address }}
              </span>
            </p> -->
            <p class="m-0 fontsize-medium d-inline-block">
              <b class=" fontsize-medium d-inline-block pr-1">
                ساعات پاسخگویی :
              </b>
              <span>
                10 الی 21
              </span>
            </p>
            <div class="">
              <b class=" fontsize-medium d-inline-block pr-1">
                شماره تماس پشتیبانی :
              </b>
              <template v-if="!loading">
                <a
                  :href="`tel:${content.settings.site.support_number}`"
                  class="fontsize-medium font-weight-bolder text-color-666 d-md-inline-block d-sm-block"
                  >{{ content.settings.site.support_number }}</a
                >
              </template>
              <template v-else>
                <span
                  ><b-skeleton width="105px" class="d-inline-block mr-2"
                /></span>
              </template>
            </div>
            <div
              class="d-flex align-items-center justify-content-start"
              style="gap: 15px;"
            >
              <b class=" fontsize-medium d-inline-block pr-1">
                شبکه های اجتماعی :
              </b>
              <a
                v-if="!loading && content.settings.social.whatsapp"
                :href="!loading ? content.settings.social.whatsapp : ''"
              >
                <whatsapp />
              </a>
              <a
                v-if="!loading && content.settings.social.telegram"
                :href="!loading ? content.settings.social.telegram : ''"
              >
                <telegram />
              </a>
              <a
                v-if="!loading && content.settings.social.instagram"
                :href="!loading ? content.settings.social.instagram : ''"
              >
                <instagram />
              </a>
            </div>
          </div>
        </address>
      </div>
      <div
        class="d-flex flex-wrap align-items-center justify-content-between  down-footer"
      >
        <div
          class="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-between "
        >
          <p class="m-0">
            <svg
              class="d-sm-inline-block d-none ml-1"
              height="20"
              viewBox="0 0 512 512"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="#666"
                d="m178.925781 177.925781c-42.5 42.5-42.5 111.648438 0 154.148438s111.648438 42.5 154.148438 0c7.8125-7.8125 20.476562-7.8125 28.285156 0s7.808594 20.476562 0 28.285156c-29.046875 29.046875-67.203125 43.570313-105.359375 43.570313s-76.3125-14.523438-105.359375-43.570313c-58.09375-58.097656-58.09375-152.625 0-210.71875 58.097656-58.09375 152.625-58.09375 210.71875 0 7.8125 7.808594 7.8125 20.472656 0 28.285156-7.808594 7.808594-20.472656 7.808594-28.285156 0-42.5-42.5-111.648438-42.5-154.148438 0zm258.09375-102.945312c-48.351562-48.351563-112.640625-74.980469-181.019531-74.980469s-132.667969 26.628906-181.019531 74.980469c-48.351563 48.351562-74.980469 112.640625-74.980469 181.019531s26.628906 132.667969 74.980469 181.019531c48.351562 48.351563 112.640625 74.980469 181.019531 74.980469 46.8125 0 92.617188-12.757812 132.460938-36.894531 9.449218-5.722657 12.46875-18.019531 6.746093-27.46875-5.726562-9.449219-18.023437-12.46875-27.46875-6.742188-33.59375 20.347657-72.234375 31.105469-111.738281 31.105469-119.101562 0-216-96.898438-216-216s96.898438-216 216-216 216 96.898438 216 216c0 42.589844-12.664062 84.042969-36.625 119.882812-6.140625 9.183594-3.671875 21.605469 5.507812 27.742188 9.1875 6.140625 21.605469 3.671875 27.742188-5.507812 28.378906-42.441407 43.375-91.585938 43.375-142.117188 0-68.378906-26.628906-132.667969-74.980469-181.019531zm0 0"
              />
            </svg>
            تمامی حقوق این سایت مربوط به
            <span class="font-weight-bold">سایت آنجل</span> می باشد
          </p>
          <p class="m-0">
            طراحی شده:
            <a
              class="m-0"
              style="color: var(--newTheme-color)"
              target="_blank"
              href="https://shetabit.com/"
              >گروه شتاب</a
            >
          </p>
        </div>
        <div class="enamad-box enamad-des">
          <!-- <a
            data-v-76b5372e=""
            referrerpolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=333878&amp;Code=rPWS2Gf47zh4FD6LE0u7"
            ><img
              data-v-76b5372e=""
              referrerpolicy="origin"
              src="../../../../assets/images/enamd_log.png"
              alt=""
              id="rPWS2Gf47zh4FD6LE0u7"
              style="cursor: pointer;"
          /></a> -->
          <a
            target="_blank"
            href="https://trustseal.enamad.ir/?id=682193&Code=lq2TFifdO5YHTEgS5YMrdZzBzdnsJuGK"
            ><img
              referrerpolicy="origin"
              src="../../../../assets/images/enamd_log.png"
              alt=""
              style="cursor:pointer"
              code="lq2TFifdO5YHTEgS5YMrdZzBzdnsJuGK"
          /></a>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import telegram from "@/parts/Front/components/icons/telegram.vue";
import whatsapp from "@/parts/Front/components/icons/whatsapp.vue";
import instagram from "@/parts/Front/components/icons/instagram.vue";

import findUrl from "@/libraries/links/LinkResolver";
import DynamicLinker from "./DynamicLinker";
import { BSkeleton } from "bootstrap-vue";
import ZWhatsappSvg from "./ZWhatsappSvg";
import SocialNetworks from "./SocialNetworks";

export default {
  name: "Footer",
  components: {
    SocialNetworks,
    ZWhatsappSvg,
    DynamicLinker,
    BSkeleton,
    instagram,
    whatsapp,
    telegram,
  },
  computed: {
    // دریافت محتوای درخواست هوم
    content() {
      return this.$store.getters["front/getHomeData"];
    },
    loading() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },
  data() {
    return {
      email: null,
      disabled: false,
    };
  },
  methods: {
    findUrl,
    sendEmail() {
      if (!this.email) {
        return window.swal({
          title: "خطا!",
          text: "لطفا ایمیل خود را وارد کنید",
          icon: "warning",
          timer: 2000,
        });
      } else if (!this.validEmail(this.email)) {
        return window.swal({
          title: "خطا!",
          text: "لطفا فرمت ایمیل خود را به درستی وارد کنید",
          icon: "warning",
          timer: 2000,
        });
      }
      const fromData = new FormData();
      fromData.append("email", this.email);
      this.disabled = true;
      this.$axios.post("/front/newsletters", fromData).then((response) => {
        this.disabled = false;
        this.email = null;
        window.swal({
          title: "تبریک",
          text: "ایمیل شما برای عضویت در خبرنامه ما ثبت سیستم شد",
          icon: "success",
          timer: 2000,
        });
      });
    },
    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    findAboutLink(menu) {
      if (menu && menu.length) {
        console.log(
          menu.find((item) => item.title == "    درباره ما"),
          "sssssssssssssssssssssssss"
        );
        return menu.find((item) => item.title.trim() == "درباره ما");
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.enamad-box img {
  width: 70px;
}

.enamad-mobile {
  display: none;
}

.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.footer {
  margin-top: 50px;
  padding-bottom: 8px;
  box-shadow: 0 0 10px rgba(128, 128, 128, 0.617);
}

.row-footer {
  width: 100%;
  height: 40px;
  margin-bottom: 50px;
  background-color: var(--newTheme-color);
}

.content-footer {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  justify-items: center;
}

.contact-footer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.down-footer {
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid rgba(128, 128, 128, 0.459);
}

.content-footer .fontsize-large {
  font-weight: 800 !important;
}

@media screen and (max-width: 800px) {
  .content-footer {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 1.5rem;
    justify-items: right;
  }

  .down-footer {
    flex-direction: column;
    font-size: 14px;
  }

  .footer {
    margin-top: 35px;
    padding-bottom: 75px;
  }

  .row-footer {
    width: 100%;
    height: 40px;
    margin-bottom: 35px;
    background-color: var(--newTheme-color);
  }

  .fontsize-large {
    font-size: 18px;
    font-weight: 800 !important;
  }
}

@media screen and (max-width: 600px) {
  .enamad-box.enamad-des {
    display: none;
  }

  .enamad-mobile {
    display: flex;
  }

  .quick-access {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
  }
}

/*.footer-grid {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
}
.imgSkeleton {
  height: 70px;
}

.errorEmail {
  border-bottom: 1px solid red;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.enamad-container {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
}

.newsletter-btn {
  background: var(--newTheme-color);
  color: white;
}

.get-subscribe form {
  height: 40px;
  border: 2px solid var(--color-da);
  transition: 0.3s;
}

.get-subscribe form:focus-within {
  border: 2px solid var(--color-theme2);
}
*/
/* .get-subscribe form input::placeholder{
    color: white;
} */

/*.get-subscribe form svg > path {
  transition: 0.3s;
}

.get-subscribe form button {
  height: 38px;
  transition: 0.3s;
  position: relative;
  bottom: -1px;
  left: -3px;
}

.get-subscribe form button:hover {
  box-shadow: 0 0 5px #ccc;
}

.newsletter-title {
  flex-shrink: 0;
  font-size: 19px;
  font-weight: bold;
  margin-left: 10px;
}
@media screen and (max-width: 768px) {
  .footer-grid {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(1, 1fr);
  }
}
@media screen and (max-width: 587px) {
  .newsletter-title {
    font-size: 1rem;
  }
    
}

p {
  font-size: 14px;
}*/
</style>
